import React from 'react';
import './Breadcrumb.css';

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
  active?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav className="breadcrumb-nav">
      <ol className="breadcrumb-list">
        {items.map((item, index) => (
          <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`}>
            {item.onClick && !item.active ? (
              <button onClick={item.onClick} className="breadcrumb-link">
                {item.label}
              </button>
            ) : (
              <span className="breadcrumb-text">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <span className="breadcrumb-separator">
                <i className="material-icons">chevron_right</i>
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
